
export const environment = {
    production: true,
   //api: 'http://localhost:3000/'
   // api: 'http://waste.coderserver.com/'
    api: 'https://wcollection.georefapp.com/' // active
};

